import { createAction, props } from '@ngrx/store'

export const setSelectedProgram = createAction(
  '[Legacy] Set Selected Program',
  props<{
    clientId: string | null
    yearId: string | null
    programId: string | null
  }>(),
)

export const clearSelectedProgram = createAction('[Legacy] Clear Selected Program')

export const setSelectedStructure = createAction(
  '[Legacy] Set Selected Structure',
  props<{ structureId: string | null }>(),
)

export const loadActiveContext = createAction('[Legacy] Load Active Context')

/**
 * Dispatched only when the user explicitly applies a selection (via a dialog).
 * This is the sole trigger for persisting the active context to the backend.
 */
export const applyActiveContext = createAction(
  '[Legacy] Apply Active Context',
  props<{
    clientId: string | null
    yearId: string | null
    programId: string | null
    structureId: string | null
  }>(),
)

export const activeContextLoaded = createAction(
  '[Legacy] Active Context Loaded',
  props<{
    clientId: string | null
    yearId: string | null
    programId: string | null
    structureId: string | null
  }>(),
)

export const markActiveContextLoaded = createAction('[Legacy] Mark Active Context Loaded')

export const setActiveContextNames = createAction(
  '[Legacy] Set Active Context Names',
  props<{
    clientName: string | null
    yearLabel: string | null
    programName: string | null
  }>(),
)
